import * as React from 'react';
import StepperModel from '../models/StepperModel';
import { observer } from 'mobx-react-lite';
import { WIZARD_STEPS } from '../steps/wizard-steps-description';
import { FormManagerProvider } from '../context/FormManagerProvider';

interface FCProps {}

const StepRender: React.FC<FCProps> = observer(({}) => {
  const currentStep = StepperModel.currentStep;

  React.useEffect(() => {
    WIZARD_STEPS[currentStep].step?.onInit();
  }, [currentStep]);

  const currentStepComponent = WIZARD_STEPS[currentStep].component;

  return (
    <FormManagerProvider>
      {React.createElement(currentStepComponent, {})}
    </FormManagerProvider>
  );
});

export default StepRender;
